import { useTranslation } from 'react-i18next';
import { usePortalActiveClinic } from '@/lib/portalActiveClinic';

/**
 * Patient portal dashboard page.
 */
export function PortalDashboard() {
  const { t } = useTranslation();
  const { clinics, activeClinicId, isLoading } = usePortalActiveClinic();
  const activeClinic = clinics.find((c) => c.clinic_id === activeClinicId);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
          {t('portal.dashboard.title')}
        </h1>
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
          {isLoading
            ? t('app.loading')
            : activeClinic
              ? t('portal.dashboard.welcome_clinic', { clinic: activeClinic.clinic_name })
              : t('portal.dashboard.welcome')}
        </p>
      </div>

      {clinics.length > 1 && (
        <div className="rounded-lg border border-indigo-200 bg-indigo-50 p-4 dark:border-indigo-800 dark:bg-indigo-900/20">
          <p className="text-sm text-indigo-800 dark:text-indigo-200">
            {t('portal.dashboard.multi_clinic_hint')}
          </p>
        </div>
      )}

      <div className="rounded-lg border-2 border-dashed border-gray-300 bg-white p-12 text-center dark:border-gray-700 dark:bg-gray-800">
        <div className="mx-auto max-w-md">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white">
            {t('portal.dashboard.coming_soon_title')}
          </h3>
          <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
            {t('portal.dashboard.coming_soon_body')}
          </p>
        </div>
      </div>
    </div>
  );
}
